"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatefulBadge = exports.ScrollWrapper = exports.Heading = exports.FlexContainer = exports.FilterWrapper = exports.FilterGroups = exports.FilterCount = exports.FilterContainer = exports.FilterBar = exports.CloseIcon = exports.CTAContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = _interopRequireWildcard(require("../../../../../components/breakpoints"));
var _index = _interopRequireDefault(require("../../../../../components/CTAList/index.styled"));
var _DynamicHeading = require("../../../../../components/DynamicHeading");
var _LexusTypography = require("../../../../../components/LexusTypography");
var _CategorySelector = _interopRequireDefault(require("../../../../../components/TileGrid/CategorySelector"));
var _CategorySelector2 = require("../../../../../components/TileGrid/CategorySelector.styled");
var _IconLibrary = require("../../../../../packages/IconLibrary");
var _FilterBar = _interopRequireDefault(require("../../../FilterBar"));
var _index2 = require("../../../FilterBar/index.styled");
const FilterCount = exports.FilterCount = _styledComponents.default.div`
  ${(0, _LexusTypography.nobel)({
  sizing: "subheading14"
})}
  font-style: italic;
`;
const Heading = exports.Heading = (0, _styledComponents.default)(_DynamicHeading.DynamicHeading)`
  ${(0, _LexusTypography.nobel)({
  sizing: "subheading12"
})}
`;
const CTAContainer = exports.CTAContainer = _styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 2;
  gap: 20px;
`;
const FilterGroups = exports.FilterGroups = (0, _styledComponents.default)(_FilterBar.default)`
  margin: 0 0 16px 0;
  flex-wrap: nowrap;
  white-space: nowrap;
  ${(0, _breakpoints.default)("tablet", "up")} {
    gap: 16px 32px;
  }
  ${_index.default.CTAListWrapper} {
    white-space: nowrap;
    ${(0, _breakpoints.default)("desktop", "up")} {
      display: flex;
      flex-direction: column;
    }
  }
`;
const FilterContainer = exports.FilterContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const FilterWrapper = exports.FilterWrapper = (0, _styledComponents.default)(FilterGroups)`
  gap: 16px 16px;
  margin: 0;
`;
const FilterBar = exports.FilterBar = (0, _styledComponents.default)(_FilterBar.default)`
  --badge-active-color: #ffffff;
  --badge-border-color: rgba(0, 0, 0, 0.3);
  --badge-border-color-active: rgba(0, 0, 0, 1);

  flex-wrap: nowrap;
  gap: 8px 4px;
  flex-shrink: 0;
`;
const CloseIcon = exports.CloseIcon = (0, _styledComponents.default)(_IconLibrary.CloseHeavy)`
  margin: 0 3px 0 6px;
  width: 8.5px;
  height: 8.5px;
`;
const StatefulBadge = exports.StatefulBadge = (0, _styledComponents.default)(_index2.Badge)`
  color: inherit;
  display: flex;
  align-items: center;
  margin: 1px;
  padding: 6px 11px;
  ${(0, _LexusTypography.nobel)({
  sizing: "link13",
  weight: "regular"
})}
  border-width: 1px;
  border-style: solid;
  border-color: ${function (_ref) {
  let {
    $active
  } = _ref;
  return $active ? "var(--badge-border-color-active)" : "1px solid var(--badge-border-color)";
}};
  background: ${function (_ref2) {
  let {
    $active
  } = _ref2;
  return $active ? "var(--badge-active-color)" : "transparent";
}};
  &:hover {
    margin: 0;
    border-width: 2px;
  }

  &:after {
    background: none;
    width: 0;
  }
`;
const ScrollWrapper = exports.ScrollWrapper = (0, _styledComponents.default)(_CategorySelector.default)`
  background: inherit;
  margin: 0;
  padding: 0;
  position: relative;
  overflow-x: hidden;
  justify-content: start;
  ${(0, _breakpoints.breakpoint)("desktop", "up")} {
    width: auto;
  }
  ${_CategorySelector2.CategorySelector} {
    display: flex;
    gap: 16px;
    padding: 0 8px 0 8px;
    scroll-snap-type: x mandatory;
    ${(0, _breakpoints.breakpoint)("desktop", "up")} {
      border: none;
    }
  }
`;
const FlexContainer = exports.FlexContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  gap: 24px 0;
  ${(0, _breakpoints.breakpoint)("desktop", "up")} {
    padding-top: 32px;
    gap: 32px 0;
  }
`;